import cookie from "js-cookie";
import "./ImpersonationBanner.css";

import { PathologyWatchButton as Button } from "components/customInputs/buttons/Button";

const ImpersonationLogOutButton = ({ type }: { type?: string }) => {
  const csrfToken = cookie.get("csrftoken");
  const {
    REACT_APP_BACKEND_PROTOCOL,
    REACT_APP_BACKEND_HOST,
    REACT_APP_BACKEND_PORT,
  } = process.env;
  const isLink = type === "link";
  const djangoAdminUrl = `${REACT_APP_BACKEND_PROTOCOL}://${REACT_APP_BACKEND_HOST}:${REACT_APP_BACKEND_PORT}`;

  //  After the form action is complete, this will redirect to the LOGOUT_REDIRECT_URL
  // set in base.py: "/active?logout=true"
  return (
    <form
      action={`${djangoAdminUrl}/hijack/release/`}
      method="POST"
      aria-labelledby="impersonation-log-out-button"
    >
      <input type="hidden" name="csrfmiddlewaretoken" value={csrfToken} />
      <Button
        id="impersonation-log-out-button"
        type="submit"
        color={isLink ? "red" : "grey"}
        className={isLink ? "pwButton--borderless" : ""}
      >
        Log out all users
      </Button>
    </form>
  );
};

export default ImpersonationLogOutButton;
